import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
  breakpoint:{
    scrollBarWidth: 12
  },
  icons: {
    iconfont: 'fa',
  },
  theme: {
    themes: {
      light: {
        primary: "#ff5744", // #ff5744
        secondary: "#263238", // GLB ORIGINAL #424242
        accent: "#0277BD", // #3F51B5,
        cool_purple: "#6200ea",
        admin_secondary: "#37474F"
      },
    },
  }
});
